import { Icon } from "@components";
import { stackEnum } from "@utilities/enums";
import { useScreenSize } from "@utilities/hooks";
import { FC, useMemo } from "react";
import { NavItemType } from "../useController";
import { User } from "@utilities/types";
import { toIsoDateFr } from "@utilities/functions";

interface Props {
    entrepriseName?: string;
    collaborator?: User
    activeStack: keyof typeof stackEnum;
    isMenuOpen: boolean;
    navItems: NavItemType[];
    onLogout: () => void;
    onNavigateTo: (mavItem: NavItemType)=> void;
}

export const LeftSidebar: FC<Props> = ({ 
    entrepriseName,
    collaborator,
    activeStack,
    isMenuOpen,
    navItems,
    onLogout,
    onNavigateTo,
}) => {
    
    const { isMobile } = useScreenSize();

    const sectionWidth = useMemo(() => (isMobile ? 'w-full' : 'lg:w-1/5'), [isMobile]);

    const mainClasStyle = useMemo(() => (
        `${isMenuOpen ? 'absolute top-0 left-0 w-full h-full bg-opacity-90 z-20' : 'hidden'} 
        ${sectionWidth} bg-blue-100 text-white space-y-6 transition-all lg:block lg:flex lg:flex-col`
    ), [isMenuOpen, sectionWidth]);

    return (
        <div
            className={mainClasStyle}
        >
            <div className="sticky top-0 z-10 p-4 bg-primary text-white">
                {/* Nom de l'entreprise */}
                <h2 className="text-lg font-bold text-center mb-4">{entrepriseName || `"Nom de l'entreprise"`}</h2>
                <div className="bg-white p-4 rounded-xl">
                    <p className="text-sm text-primary font-semibold">
                        Hello {collaborator?.firstname || `"Votre prénom"`}
                    </p>
                    <p className="text-xs font-thin text-success">
                        Dernier connexion le {toIsoDateFr(collaborator?.lastLoginAt || new Date())}
                    </p>
                </div>
            </div>

            <div className="flex flex-col items-center mt-4 space-y-4 flex-grow">
                {navItems.map((nav, i) => {
                    const bgColor = nav.stack === activeStack ? 'bg-secondary' : 'bg-primary';
                    const textColor = nav.stack === activeStack ? 'text-secondary' : 'text-primary';

                    if (nav.isHide) return null;

                    return (
                        <div
                            key={i}
                            className={`flex items-center bg-white p-2 rounded-tl-full rounded-bl-full shadow-md w-11/12 relative ${nav.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                                }`}
                            onClick={() => onNavigateTo(nav)}
                        >
                            {
                                nav.disabled && (
                                    <div className="absolute inset-0 bg-gray-300 bg-opacity-60 rounded-tl-full rounded-bl-full flex items-center justify-center z-10">
                                        <span className="text-xs text-gray-700 font-medium px-2 py-1 bg-white bg-opacity-80 rounded">
                                            Complétez vos informations
                                        </span>
                                    </div>
                                )
                            }

                            <div className={`${bgColor} w-16 h-16 rounded-full flex items-center justify-center ${nav.disabled ? 'opacity-50' : ''
                                }`}>
                                <Icon iconName={nav.icon as any} />
                            </div>

                            <span className={`ml-4 ${textColor} font-semibold ${nav.disabled ? 'opacity-50' : ''
                                }`}>
                                {nav.label}
                            </span>
                        </div>
                    );
                })}
            </div>

            <div className="p-4 bg-secondary text-white text-center cursor-pointer">
                <button
                    onClick={onLogout}
                    className="w-full">Déconnexion</button>
            </div>
        </div>
    );
};
